var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentsbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 10.9004C0.5 4.90117 6.10714 0.020752 13 0.020752C19.8929 0.020752 25.5 4.90117 25.5 10.9004C25.5 16.0854 21.333 20.5098 15.5375 21.5452L13.7268 24.12C13.5589 24.3585 13.2884 24.4999 13 24.4999C12.7116 24.4999 12.4411 24.3585 12.2732 24.12L10.4625 21.5461C4.66696 20.5098 0.5 16.0845 0.5 10.9004ZM4.96518 10.9004C4.96518 11.9004 5.76607 12.7136 6.75089 12.7136C7.73571 12.7136 8.53661 11.9004 8.53661 10.9004C8.53661 9.90035 7.73571 9.0871 6.75089 9.0871C5.76607 9.0871 4.96518 9.90035 4.96518 10.9004ZM13.0009 12.7136C12.0161 12.7136 11.2152 11.9004 11.2152 10.9004C11.2152 9.90035 12.0161 9.0871 13.0009 9.0871C13.9857 9.0871 14.7866 9.90035 14.7866 10.9004C14.7866 11.9004 13.9857 12.7136 13.0009 12.7136ZM17.4652 10.9004C17.4652 11.9004 18.2661 12.7136 19.2509 12.7136C20.2357 12.7136 21.0366 11.9004 21.0366 10.9004C21.0366 9.90035 20.2357 9.0871 19.2509 9.0871C18.2661 9.0871 17.4652 9.90035 17.4652 10.9004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsbutton);
export default __webpack_public_path__ + "static/media/commentsbutton.738a6e07.svg";
export { ForwardRef as ReactComponent };